import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../../api'

const initialState = {
    accuplacer: [],
    act: [],
    sat: [],
    duolingo: [],
    toefl: [],
    ielts: []
}

const transform = (data) => {
    let transformed = {
        accuplacer: [],
        act: [],
        sat: [],
        duolingo: [],
        toefl: [],
        ielts: []
    }

    data?.scores?.accuplacer?.forEach((item) => {
        transformed.accuplacer.push({
            ...item, date: new Date(item.date).toLocaleDateString(),
        })
    });

    data?.scores?.act?.forEach((item) => {
        transformed.act.push({
            ...item, date: new Date(item.date).toLocaleDateString(),
        })
    });

    data?.scores?.sat?.forEach((item) => {
        transformed.sat.push({
            ...item, date: new Date(item.date).toLocaleDateString(),
        })
    });

    data?.scores?.duolingo?.forEach((item) => {
        transformed.duolingo.push({
            ...item, date: new Date(item.date).toLocaleDateString(),
        })
    });

    data?.scores?.toefl?.forEach((item) => {
        transformed.toefl.push({
            ...item, date: new Date(item.date).toLocaleDateString(),
        })
    });

    data?.scores?.ielts?.forEach((item) => {
        transformed.ielts.push({
            ...item, date: new Date(item.date).toLocaleDateString(),
        })
    });

    transformed.bestTest = data.bestTest;

    return transformed;
}

const scoresSlice = createSlice({
    name: 'applicant-detail-scores',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // has503 — also populate from the Scholars-specific details query (same payload shape).
        const onFulfilled = (state, { payload }) => {
            if (payload?.details?.testScores) {
                const transformedData = transform(payload?.details?.testScores);
                return { ...transformedData };
            }
        };
        builder.addMatcher(graphqlApi.endpoints.getApplicationDetails.matchFulfilled, onFulfilled);
        builder.addMatcher(graphqlApi.endpoints.getScholarsApplicationDetails.matchFulfilled, onFulfilled);
    }
});

export const selectScoresData = (state) => state.scoresSlice

export default scoresSlice.reducer;